import Component from "@ember/component"

/* eslint-disable */
export default class UserBeforeUpgrade extends Component.extend() {}
